/* Svensk katalog for locale-investment-quick-purchase.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'investments.quickPurchaseTitle': 'Kontrollera och godkänn köpet',
  'investments.quickPurchaseIntro': 'Plumme har läst dokumentet och förberett köpet. Kontrollera beloppen och godkänn.',
  'investments.quickExistingInstrument': 'Köpet registreras på befintlig investering: {name}.',
  'investments.quickClassification': 'Bokföringskonto',
  'investments.quickCurrentAsset': '1810 · Marknadsnoterad omsättningstillgång',
  'investments.quickCurrentAssetName': 'Marknadsnoterade aktier och fondandelar',
  'investments.quickLongTerm': '1350 · Långfristig investering',
  'investments.quickBankRequired': 'Företaget måste ha ett aktivt NOK-bankkonto innan köpet kan bokföras.',
  'investments.quickTaxLater': 'Klargörs automatiskt utifrån års- och skattedokumentationen',
  'investments.editCurrency': 'Ändra valuta',
  'investments.editFact': 'Redigera {field}',
  'investments.quickActualNokAmount': 'Faktiskt debiterat i NOK',
  'investments.quickActualNokHelp': 'Ange NOK-beloppet som faktiskt debiterades för köpet i {currency}.',
  'investments.quickResult': 'När du godkänner skapar Plumme investeringen, bokför köpet och uppdaterar innehavet. En entydig banktransaktion kopplas automatiskt nu eller nästa gång Investeringar öppnas.',
  'investments.quickApprove': 'Godkänn, bokför och uppdatera innehav',
  'investments.quickApproving': 'Bokför köpet …',
  'investments.quickSaleTitle': 'Kontrollera och godkänn försäljningen',
  'investments.quickSaleIntro': 'Plumme har läst försäljningsverifikationen och beräknat redovisnings- och skatteeffekten utifrån registrerad historik.',
  'investments.saleCalculating': 'Beräknar FIFO och anskaffningsvärde …',
  'investments.saleCannotQuickApprove': 'Detta saknas innan försäljningen kan snabbgodkännas',
  'investments.saleInstrumentMissing': 'Investeringen finns inte i registret. Registrera ingående innehav eller tidigare köp först.',
  'investments.saleInstrumentAmbiguous': 'Flera investeringar matchar dokumentet. Välj rätt investering manuellt.',
  'investments.saleTaxTreatmentMissing': 'Skattebehandlingen är inte klargjord för investeringen.',
  'investments.instrumentTypeUnsupported': 'Instrumenttypen känns igen, men bokföring för den här typen stöds inte ännu.',
  'investments.netSettlement': 'Nettoavräkning',
  'investments.releasedBookCost': 'Frigjort redovisningsmässigt anskaffningsvärde',
  'investments.releasedBookValue': 'Frigjort bokfört värde',
  'investments.releasedTaxCost': 'Frigjort skattemässigt anskaffningsvärde',
  'investments.bookProfitLoss': 'Redovisningsmässig vinst/förlust',
  'investments.taxProfitLoss': 'Skattemässig vinst/förlust',
  'investments.fifoCalculation': 'Beräknad FIFO',
  'investments.quickSaleResult': 'Godkännande bokför försäljningen, uppdaterar innehavet och kopplar en entydig bankavräkning automatiskt.',
  'investments.quickApproveSale': 'Godkänn, bokför och uppdatera innehav',
  'investments.completeSale': 'Fyll i försäljningen',
});
